import type { SEARCH_SITE_WRAPPER_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/search-site-wrapper/search-site-wrapper.fr.ts";
import type { SearchSiteTab } from "~ui/@modules/home/stores/search-site-store.ts";

const fieldPlaceholders: Record<string, string> = {
  siteId: "Site Id",
  siteExternalId: "External Id",
  siteAddress: "Address",
  sitePostalCode: "Postal Code",
  siteCity: "City",
  siteCountry: "Country",
  siteDeliveryPoint: "Delivery Point",
  subscriberId: "Subscriber Id",
  firstname: "Firstname",
  lastname: "Lastname",
  email: "Email",
  phone: "Phone number",
  companyName: "Company",
  pilotHwId: "Pilot - Hw Id",
  pilotCsId: "Pilot - Cs Id",
  modulatorHwId: "Modulator - Hw Id",
  modulatorCsId: "Modulator - Cs Id",
  modulatorSerialNumber: "Modulator - Serial number",
  modulatorNeuronId: "Modulator - Neuron Id",
  pilotSerial: "Pilot - Numéro de série",
};

const tabs: Record<SearchSiteTab, string> = {
  common: "Global",
  modulator: "Modulator",
  pilot: "Pilot",
  site: "Site",
  subscriber: "Subscriber",
};

export const SEARCH_SITE_WRAPPER_ENGLISH_LOCALE = {
  filters: "Filters",
  clearFilters: "Clear filters",
  tabs: tabs,
  commonTabLegends: {
    site: "Site",
    subscriber: "Subscriber",
    pilot: "Pilot",
    modulator: "Modulator",
  },
  fields: {
    placeholders: fieldPlaceholders,
  },
} satisfies typeof SEARCH_SITE_WRAPPER_FRENCH_LOCALE;
